<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import ErrorMessage from "../../components/error-message";
import VueSweetalert2 from "vue-sweetalert2";

/**
 * Basic-table component
 */
export default {
  components: { ErrorMessage, Layout, PageHeader },
  data() {
    return {
      title: "Vendor List",
      items: [
        {
          text: "Vendor",
          href: "/",
        },
        {
          text: "Admin List",
          active: true,
        },
      ],
      vendors: [],
        errors: null,
        visible:false,
        message:"",
        status:"",
        search:"",
    };
  },
  mounted() {
    this.getVendorList();
  },
    computed: {
        filteredList() {
            return this.vendors.filter(vendor => {
                return vendor.uuid.toLowerCase().includes(this.search.toLowerCase())
                || vendor.api_provider.toLowerCase().includes(this.search.toLowerCase())
                || vendor.api_name_tag.toLowerCase().includes(this.search.toLowerCase())
            })
        }
    },
  methods: {
      onClose(){
          this.visible=false;
      },
      searchFilterFunc2(val) {
          this.search=val;
      },
    async deleteWarning(vendor) {
      var _this = this;
      try {
        this.$swal({
          title: "Are you sure?",
          text: "You can't revert your action",
          type: "error",
          showCancelButton: true,
          confirmButtonText: "Yes, Delete it!",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            _this.deleteItem(vendor);
          } else {
            this.$swal("Cancelled", "", "info");
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    async getVendorList() {
      try {
        axios
          .get("/api/vendor/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.vendors = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
      async apiVendorStatus(id) {
          try {
              axios
                  .post("/api/vendor/status/" + id, {
                      accessToken: localStorage.getItem("access_tocken"),
                  })
                  .then((response) => {
                      if (response.data.status) {
                          this.status=response.data.data.status;
                          this.$swal("Status Changed Successfully");
                          this.getVendorList();
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      async apiVendorStatusWarning(id) {
          var _this = this;
          try {
              this.$swal({
                  title: "Are you sure?",
                  text: "You can't revert your action",
                  type: "error",
                  showCancelButton: true,
                  confirmButtonText: "Yes, Change status!",
                  cancelButtonText: "No",
                  showCloseButton: true,
                  showLoaderOnConfirm: true,
              }).then((result) => {
                  if (result.value) {
                      _this.apiVendorStatus(id);
                  } else {
                      this.$swal("Cancelled", "", "info");
                  }
              });
          } catch (err) {
              console.log(err);
          }
      },
    deleteItem: function deleteItem(vendor) {
      var _this = this;
      axios
        .post("/api/vendor/delete/" + vendor.uuid, {
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then(function (response) {
            if(response.data.status){
                // _this.getAgentList();
                // _this.hasDeleted = false;
                _this.getVendorList();
                _this.hasDeleted = false;
                _this.$swal.fire({
                    position: 'top-end',
                    icon: 'error',
                    title: 'Successfully Delete API Vendor',
                    showConfirmButton: false,
                    timer: 1000
                });
            } else {
                var str = response.data.message;
                var jsonParse = JSON.parse(str);
                _this.errorCheck(jsonParse);
            }
        });
    },
      errorCheck(obj) {
          if(obj.statusCode == 403){
              this.visible=true;
              this.message="Access Permission Denied";
              this.errors = obj.message;
          }else if (obj.error) {
              this.errors = obj.message;
          } else if (obj.message == "Token has expired") {
              this.$swal.fire({
                  title: 'LogOut!',
                  text: 'Token Has Expired',
                  icon: 'error',
                  toast:'true',
                  position: 'top-end',
              });
              this.$router.push({ name: "logout" });
          } else if (obj.message !== "Token has expired") {
              this.errors = obj.message;
          } else {
              this.flashMessage.show({
                  time: 5000,
                  status: "error",
                  title: "Error",
                  message: "Problem in data save",
              });
          }
      },
  },
};
</script>

<template>
  <Layout @CustomEventInputChangedAll="searchFilterFunc2">
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
<!--            <h4 class="card-title">Responsive tables</h4>-->
            <div class="table-responsive table-responsive-sm">
              <table class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th>SL</th>
                    <th>API Provider</th>
                    <th>Name Tag</th>
                    <th>User Name</th>
                    <th>Traget Branch</th>
                      <th>IPCC Country Code</th>
                    <th>IPCC</th>
                    <th>Balance</th>
                      <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(vendor,index) in filteredList" v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                    <td>{{vendor.api_provider}}</td>
                    <td>{{vendor.api_name_tag}}</td>
                    <td v-if="vendor.username!=null">{{vendor.username}}</td>
                      <td v-else>null</td>
                    <td v-if="vendor.target_branch!=null">{{vendor.target_branch}}</td>
                      <td v-else>null</td>
                      <td v-if="vendor.ipcc_country_code!=null">{{vendor.ipcc_country_code}}</td>
                      <td v-else>null</td>
                      <td v-if="vendor.ipcc !=null">{{vendor.ipcc}}</td>
                      <td v-else>null</td>
                    <td v-if="vendor.balance!=null">{{vendor.balance}}</td>
                      <td v-else>null</td>
                      <td>{{vendor.is_active==1?'Active':'Deactive'}}</td>
                    <td><router-link :to="{ name: 'vendor_update', params: {uuid: vendor.uuid } }" class="btn btn-primary btn-small"><i class="fas fa-edit"></i> Edit</router-link> </td>
                      <td><button @click.prevent="deleteWarning(vendor)" class="btn btn-danger btn-small"><i class="fa fa-trash"></i> Delete</button></td>
                      <td><button v-if="vendor.is_active=='1'" class="btn btn-primary btn-small" @click.prevent="apiVendorStatusWarning(vendor.uuid)"><i class="fas fa-edit"></i> Deactivate</button><button style="width:100%" v-else class="btn btn-primary btn-small" @click.prevent="apiVendorStatusWarning(vendor.uuid)"><i class="fas fa-edit"></i> Activate</button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
